import { render, staticRenderFns } from "./BuildingTypeSelector.vue?vue&type=template&id=33a53be8"
import script from "./BuildingTypeSelector.vue?vue&type=script&lang=ts"
export * from "./BuildingTypeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports